"use strict";

export const initQuickUseGuideSwiper = async () => {
    const swiperElement = document.querySelector('.quick-use-guide__content');
    if (!swiperElement) return;

    try {
        const Swiper = (await import('swiper')).default;
        const { Navigation, Pagination, EffectFade } = await import('swiper/modules');
        
        new Swiper(swiperElement, {
            modules: [Navigation, Pagination, EffectFade],
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            speed: 600,
            allowTouchMove: true,
            navigation: {
                nextEl: '.pagination-btn--next',
                prevEl: '.pagination-btn--prev',
            },
            pagination: {
                el: '.quick-use-guide__pagination-dots',
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="pagination-dot ' + className + '">' + (index + 1) + '</span>';
                },
            },
            on: {
                init: function() {
                    const paginationText = document.querySelector('.pagination-text');
                    if (paginationText) {
                        paginationText.textContent = '1 / ' + this.slides.length;
                    }
                },
                slideChange: function() {
                    const currentSlide = this.realIndex + 1;
                    const totalSlides = this.slides.length;
                    const paginationText = document.querySelector('.pagination-text');
                    if (paginationText) {
                        paginationText.textContent = currentSlide + ' / ' + totalSlides;
                    }
                }
            }
        });
    } catch (error) {
        console.error("Failed to load Quick Use Guide Swiper:", error);
    }
};
